// white listing these routes as these are to executed in unifyapps context
const whitelistedRoutes = ['custom', 'standard', 'create', 'edit', 'share'];

// code apps are nested under /interfaces/code-builder/{appId}; the interface id
// is that app id (the entity's own id), one segment further along — NOT the
// literal "code-builder" segment. The chat rides as ?sessionId= and is NOT part
// of this resolution: governance and the app-id header scope to the app, which
// is what stays constant as the user switches between the app's sessions.
const CODE_BUILDER_SEGMENT = 'code-builder';
// whitelisting Interface Activity Route, as we need to show Platform Users as filter instead of Application Users
const getIsWhitelistedRoute = (interfaceIdFromRoute: string, route: string) => {
  if (route.endsWith(`${interfaceIdFromRoute}/activity`)) return true;
  return whitelistedRoutes.some((it) => it === interfaceIdFromRoute);
};

const getEntityTypeIndex = ({ route, params }: { route: string; params: string[] }) => {
  // template component url is created as /p/0/interfaces/template-components/new-temp.
  // in this case interfaceId doesnt lie just after interfaces but after template-components, so we must return the index
  // of template-components
  if (route.includes('interfaces/template-components')) {
    return params.indexOf('template-components');
  }

  return params.indexOf('interfaces');
};

export const extractInterfaceFromRoute = (route: string): string | null | undefined => {
  const params = route.split('/');
  const indexOfInterfaces = getEntityTypeIndex({ route, params });
  if (indexOfInterfaces === -1) {
    return null;
  }

  const interfaceIdFromRoute = params[indexOfInterfaces + 1];

  // for a code app the interface id is the app id one segment further along
  // (…/interfaces/code-builder/{appId}/…). without this the app-id header would
  // be the literal "code-builder" and governance queries wouldn't scope to the app.
  if (interfaceIdFromRoute === CODE_BUILDER_SEGMENT) {
    const appId = params[indexOfInterfaces + 2];
    return appId || null;
  }

  if (getIsWhitelistedRoute(interfaceIdFromRoute, route)) {
    return null;
  }
  return interfaceIdFromRoute;
};
